import React from "react";

import { Carousel, Button } from "antd";

import "antd/es/menu/style/css";

import { DoubleRightOutlined, DoubleLeftOutlined } from "@ant-design/icons";

import { HashLink as Link } from "react-router-hash-link";

function PrtNextArrow(props) {
  console.log("props");
  console.log(props);
  const { onClick } = props;
  return (
    <Button
      type="text"
      style={{
        position: "absolute",
        display: props.onClick === null ? "none" : "",
        top: 0,
        right: 0,
        height: "100%",
        background: "rgb(255, 255, 255, 0.5)",
        width: "20px",
      }}
      icon={<DoubleRightOutlined />}
      onClick={onClick}
    />
  );
}

function PrtPrevArrow(props) {
  const { onClick } = props;
  return (
    <Button
      type="text"
      style={{
        position: "absolute",
        display: props.onClick === null ? "none" : "",
        top: 0,
        left: 0,
        height: "100%",
        background: "rgb(255, 255, 255, 0.5)",
        width: "20px",
        zIndex: "99",
      }}
      icon={<DoubleLeftOutlined />}
      onClick={onClick}
    />
  );
}

export default class PagesMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: this.props.location.hash,
    };
  }

  componentDidMount() {
    console.log(this.slider);
    this.slider.onWindowResized();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    console.log(this.slider);
    if (prevProps.location.hash !== this.props.location.hash) {
      this.setState({
        current: this.props.location.hash,
      });
    }
  }

  /* handleClick = (e) => {
    this.setState({
      current: e.key,
    });
  }; */

  getRoutes = () => {
    return this.props.info.ROUTES;
  };

  renderMenu = () => {
    const menuArr = this.getRoutes();
    return menuArr.map((el, i) => {
      if (el.CHILDS.length === 0) {
        return (
          <div
            style={{
              width: "140px",
            }}
            className={`geFont ${
              el.URL === this.state.current ? "mobilePageActive" : ""
            }`}
            key={i}
          >
            <Link
              to={el.URL}
              scroll={(el) => {
                const elementPosition = el.offsetTop - 105;
                window.scroll({
                  top: elementPosition,
                  behavior: "smooth",
                });
                //el.scrollIntoView({ behavior: "smooth", top: "105" })
              }}
            >
              <div
                style={{
                  height: "100%",
                  lineHeight: "50px",
                  //padding: "0 10px",
                  borderRight: "1px solid #f0f0f0",
                  textAlign: "center",
                }}
              >
                {el.PAGE_NAME}
              </div>
            </Link>
          </div>
        );
      }
      return null;
    });
  };

  render() {
    return (
      <Carousel
        slidesToShow={1}
        slidesToScroll={2}
        dots={false}
        infinite={false}
        variableWidth
        className="mobilePage"
        focusOnSelect
        arrows
        nextArrow={<PrtNextArrow />}
        prevArrow={<PrtPrevArrow />}
        ref={(slider) => (this.slider = slider)}
      >
        {this.renderMenu()}
      </Carousel>
    );
  }
}
